const mySwiper1 = new Swiper(".swiper", {
  loop: true,
  centeredSlides: true, //アクティブなスライドを中央に表示
  slidesPerView: 1.4,
  spaceBetween: 10, //スライド間の距離
  breakpoints: {
    669: {
      slidesPerView: 1.8,
      spaceBetween: 30,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
  speed: 300, // 通常のスライド変移の速度

  autoplay: {
    delay: 3500, //3.5秒ごとにスライダを切り替える
    disableOnInteraction: true, // 矢印をクリックすると自動再生を止める
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },

  on: {
    init: function () {
      // 初期化後に最初のスライドを表示
      document.querySelector('.slider-item:first-child').style.visibility = 'visible';
    },
  },
});

// 初期状態で最初のスライドを非表示にする
document.querySelector('.slider-item:first-child').style.visibility = 'hidden';

(function() {
  let speed = 5000;
 
  const mySwiper = new Swiper(".swiper-secondary", {
    loop: true, //繰り返しをする
    centeredSlides: true, //アクティブなスライドを中央に表示
    spaceBetween: 30, //スライド間の距離
    slidesPerView:"auto",//スライド幅を指定しない
    allowTouchMove: false,
      
    speed: speed, //スライドの推移時間を1.5秒に
    // effect: "fade",
  
    autoplay: {
      delay: 0,
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
  });
 
  let getTranslate;
 
  document.querySelectorAll('.swiper-secondary').forEach(function(e){
 
    e.addEventListener('mouseover', function () {
      getTranslate = mySwiper.getTranslate();
      mySwiper.setTranslate(getTranslate);
      mySwiper.setTransition(0);
    });
 
    e.addEventListener('mouseout', function () {
      getTranslate = mySwiper.getTranslate();
 
      let getSlideWidthMgLeft = document.querySelector('.swiper-slide-active').style.marginLeft;
      if (getSlideWidthMgLeft) {
        getSlideWidthMgLeft = parseFloat(getSlideWidthMgLeft);
      } else {
        getSlideWidthMgLeft = 0;
      }
 
      let getSlideWidthMgRight = document.querySelector('.swiper-slide-active').style.marginRight;
      if (getSlideWidthMgRight) {
        getSlideWidthMgRight = parseFloat(getSlideWidthMgRight);
      } else {
        getSlideWidthMgRight = 0;
      }
 
      let getSlideWidth = document.querySelector('.swiper-slide-active').offsetWidth;
 
      let getTotalSlideWidth = getSlideWidthMgLeft + getSlideWidthMgRight + getSlideWidth;
      let diff = - getTotalSlideWidth - (getTranslate % getTotalSlideWidth);
      let diffTime = diff / -getSlideWidth;
      mySwiper.setTranslate(getTranslate + diff);
      mySwiper.setTransition(speed * diffTime);
    });
  });
})();


let currentTab = 0;

document.addEventListener("DOMContentLoaded", () => {
    showTab(currentTab);
});

function showTab(index) {
    const tabs = document.querySelectorAll(".tab");
    const contents = document.querySelectorAll(".tab-content");

    tabs.forEach((tab, idx) => {
        tab.classList.toggle("active", idx === index);
    });

    contents.forEach((content, idx) => {
        content.classList.toggle("active", idx === index);
    });

    currentTab = index;
}

function nextTab() {
    const tabs = document.querySelectorAll(".tab");
    currentTab = (currentTab + 1) % tabs.length;
    showTab(currentTab);
}

function prevTab() {
    const tabs = document.querySelectorAll(".tab");
    currentTab = (currentTab - 1 + tabs.length) % tabs.length;
    showTab(currentTab);
}


function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('DOMContentLoaded', function() {
  const sideBar = document.querySelector('.side-bar');
  const fadeInPoint = 80; // この位置をスクロールしたらフェードイン開始

  window.addEventListener('scroll', function() {
    if (window.scrollY > fadeInPoint) {
      sideBar.classList.add('visible');
    } else {
      sideBar.classList.remove('visible');
    }
  });

  // スクロールトップに戻る関数
  window.scrollToTop = function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
});
